// app/javascript/controllers/playlist_items_controller.js
import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["items", "template", "modal"];

  connect() {
    this.index = this.itemsTarget.children.length;
    this.sortable = Sortable.create(this.itemsTarget, {
      handle: ".cursor-move",
      onEnd: () => this.updatePositions(),
    });
  }

  updatePositions() {
    this.itemsTarget.querySelectorAll(".playlist-item").forEach((el, index) => {
      const positionInput = el.querySelector(".position-field");
      if (positionInput) positionInput.value = index + 1;
    });
  }

  removeItem(event) {
    event.preventDefault();
    const item = event.target.closest(".playlist-item");

    if (!item) return;

    const destroyInput = item.querySelector('input[name*="_destroy"]');

    if (destroyInput) {
      // Si el ítem ya está persistido (tiene ID), solo lo marcamos como _destroy
      destroyInput.value = "1";
      item.classList.add("hidden"); // opcional: lo ocultas visualmente
    } else {
      // Si es un ítem nuevo, simplemente lo quitamos del DOM
      item.remove();
    }

    this.updatePositions();
  }

  openPicker(event) {
    event.preventDefault();
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("hidden");
    }
  }

  closePicker(event) {
    event.preventDefault();
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden");
    }
  }
  select(event) {
    event.preventDefault();

    const dataset = event.currentTarget.dataset;

    const id = dataset.id;
    const title = dataset.title || "Recurso sin título";
    const duration = dataset.duration || "";
    const previewUrl = dataset.preview || "";

    const index = this.index;
    let html = this.templateTarget.innerHTML
      .replace(/{{id}}/g, id)
      .replace(/{{index}}/g, index)
      .replace(/{{title}}/g, title)
      .replace(/{{duration}}/g, duration)
      .replace(/{{preview}}/g, previewUrl);

    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    const durationLine = wrapper.querySelector(".duration-line");
    if (durationLine && (!duration || duration === "—")) {
      durationLine.classList.add("hidden");
    }

    const img = wrapper.querySelector(".preview-img");
    if (img && previewUrl) {
      img.src = previewUrl;
    } else if (img) {
      img.classList.add("hidden");
    }

    this.itemsTarget.appendChild(wrapper.firstElementChild);
    this.index++;
    this.updatePositions();
    this.closePicker(event);
  }
}
